import './css/style.scss'
import enterPage from './js/enterPage.js';
import Loader from './js/loader.js';
import nav from './js/nav.js';
import scroll from './js/scroll.js';
import textModal from './js/textModal.js';
import audioPlayer from './js/audioPlayer.js';
import rotateMessage from './js/rotateMessage.js';
import scrollHint from './js/scrollHint.js';
import quoteModule from './js/quoteModule.js';
import imageModule from './js/imageModule.js';
import parallaxVideoModule from './js/parallaxVideoModule.js';
import filmstrip from './js/filmstrip.js';
import mobilePageCrop from './js/mobilePageCrop.js';
import mobilePageGradient from './js/mobilePageGradient.js';
import statisticModule from './js/statisticModule.js';
import imageCaptionModule from './js/imageCaptionModule.js';
import videoOverVideoModule from './js/videoOverVideoModule.js';
import pageBorderModule from './js/pageBorderModule.js';
import imageCarouselModule from './js/imageCarouselModule.js';
import mobilePagePan from './js/mobilePagePan.js';
import signatureModule from './js/signatureModule.js';

Loader.init({ timeout: 2500 });
enterPage.init();
window.scroll = scroll;
scroll.init();
mobilePageCrop.init();
mobilePageGradient.init();
mobilePagePan.init();
videoOverVideoModule.init();
filmstrip.init();
nav.init();
window.nav = nav; // expose for pageZoom synchronization
scrollHint.init(30000);
textModal.init();
audioPlayer.init();
rotateMessage.init();
quoteModule.init();
imageModule.init();
parallaxVideoModule.init();
statisticModule.init();
imageCaptionModule.init();
pageBorderModule.init();
imageCarouselModule.init();
signatureModule.init();

const requestedPage = new URLSearchParams(window.location.search).get('page');
const targetPage = requestedPage && Array.from(document.querySelectorAll('.pages-container .page'))
	.find(page => page.dataset.id === requestedPage);
if (targetPage) {
	document.querySelector('.start-page')?.style.setProperty('display', 'none', 'important');
	nav.scrollToPage(requestedPage);
}
// pagesAuto removed: pages now statically generated into index.html by gen:pages script.

// Lenis removed; custom momentum logic now powers both desktop (horizontal) and mobile (vertical) scrolling.
